import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4b262bde"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "bottom-foot"
};
const _hoisted_2 = {
  class: "flex"
};
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"copyright\" data-v-4b262bde><div class=\"company-copy\" data-v-4b262bde><p data-v-4b262bde>版权所有<span data-v-4b262bde>安徽爱沃客信息科技有限公司</span></p></div><div class=\"beian flex\" data-v-4b262bde><a href=\"https://beian.miit.gov.cn/\" data-v-4b262bde>皖ICP备18007608号-5</a><a href=\"https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34019102000300\" data-v-4b262bde>皖公网安备 34019102000300号</a></div></div>", 1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("nav", null, [_createElementVNode("ul", _hoisted_2, [_createElementVNode("li", null, [_createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[0] || (_cache[0] = $event => $options.actionTo('/'))
  }, "人力资源")]), _createElementVNode("li", null, [_createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[1] || (_cache[1] = $event => $options.actionTo('/zhiye'))
  }, "职业教育")]), _createElementVNode("li", null, [_createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[2] || (_cache[2] = $event => $options.actionTo('/edu'))
  }, "继续教育")]), _createElementVNode("li", null, [_createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[3] || (_cache[3] = $event => $options.actionTo('/xsc'))
  }, "蓄水池")]), _createElementVNode("li", null, [_createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[4] || (_cache[4] = $event => $options.actionTo('/contact'))
  }, "联系我们")])])]), _hoisted_3]);
}